/*
 * This file is part of Mitei Server.
 * Copyright (c) 2019 f0reachARR <f0reach@f0reach.me>
 *
 * Mitei Server is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * Mitei Server is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Mitei Server.  If not, see <http://www.gnu.org/licenses/>.
 */
import { makeStyles, Paper, Typography } from '@material-ui/core';
import * as React from 'react';
export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3, 2),
        margin: theme.spacing(1, 0),
    },
}));
export const PageContainer = ({ title, children, mini }) => {
    const styles = useStyles();
    return (React.createElement(Paper, { className: styles.paper },
        React.createElement(Typography, { component: mini ? 'h6' : 'h5', variant: mini ? 'h6' : 'h5' }, title),
        children));
};
//# sourceMappingURL=index.js.map